import productLocalization from './productLocalization';
import packingLocalization from './packingLocalization';
import weightLocalization from './weightLocalization';
import breedLocalization from './breedLocalization';

export default class Product{

    static find(lang,tableProduct){
            let srb = productLocalization.product.find(x=> x.key.split(' ').join('').toLowerCase() == tableProduct.split(' ').join('').toLowerCase());  
            switch(lang){
                case 'sr':
                    return srb ? srb.sr : tableProduct;   
                case 'en':
                    return srb ? srb.en : tableProduct;   
            }
   
    }
    static findPacking(lang,tablePacking){
        let srb = packingLocalization.packing.find(x=> x.key.split(' ').join('').toLowerCase() == tablePacking.split(' ').join('').toLowerCase());  
        switch(lang){
            case 'sr':
                return srb ? srb.sr : tablePacking;   
            case 'en':
                return srb ? srb.en : tablePacking;   
        }

}
static findWeight(lang,tableWeight){
    let srb = weightLocalization.weight.find(x=> x.key.split(' ').join('').toLowerCase() == tableWeight.split(' ').join('').toLowerCase());  
    switch(lang){
        case 'sr':
            return srb ? srb.sr : tableWeight;   
        case 'en':
            return srb ? srb.en : tableWeight;   
    }

}
static findBreed(lang,tableBreed){
    let srb = breedLocalization.breed.find(x=> x.key.split(' ').join('').toLowerCase() == tableBreed.split(' ').join('').toLowerCase());  
    switch(lang){
        case 'sr':
            return srb ? srb.sr : tableBreed;   
        case 'en':
            return srb ? srb.en : tableBreed;   
    }

}
}
